import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ip.market.applications');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { Subscription } from 'rxjs';

type SaleRequestStatus =
    | 'SUBMITTED'
    | 'IN_REVIEW'
    | 'NEEDS_REVISION'
    | 'APPROVED'
    | 'REJECTED'
    | 'PUBLISHED'
    | 'CANCELLED';
type SaleRequestType = 'CREATE' | 'UPDATE' | 'DELETE';

type Seller = {
    name: string;
    company: string;
    office_name: string;
    phone: string;
    email: string;
    preferred_contact_time?: string;
};

type RightInfo = {
    right_type: string;
    category: string;
    field: string;
    technical_fields: string[];
    right_title: string;
    owner_name: string;
    registration_number: string;
    registration_date: string;
};

type SaleFile = {
    id: string;
    file_name: string;
    file_type: string;
    mime_type: string;
    size_bytes: number;
    created_at: string;
    download_url?: string;
};

type AuditEvent = {
    id: string;
    event_type: string;
    actor_id: string;
    actor_type: string;
    created_at: string;
    payload: any;
};

type SaleMessage = {
    id: string;
    body: string;
    visibility: string;
    created_by: string;
    created_at: string;
};

type StatusHistory = {
    id: string;
    from_status: SaleRequestStatus | null;
    to_status: SaleRequestStatus;
    changed_by: string;
    reason: string;
    created_at: string;
};

type SaleRequestListItem = {
    id: string;
    reference: string;
    source: 'IP_MARKET_PORTAL';
    request_type: SaleRequestType;
    status: SaleRequestStatus;
    seller: Seller;
    right: RightInfo;
    desired_price: number | null;
    sale_method: string;
    privacy_consent: boolean;
    fee_consent: boolean;
    admin_service_requested: boolean;
    created_by_admin?: boolean;
    submission_channel?: string;
    assigned_to: string | null;
    description_preview: string;
    submitted_at: string;
    updated_at: string;
    target_sale_id: string | null;
    preferred_contact_time: string;
    has_no_documents: boolean;
    file_count: number | null;
};

type SaleRequestDetail = SaleRequestListItem & {
    description: string;
    files: SaleFile[];
    messages: SaleMessage[];
    status_history: StatusHistory[];
    audit_events: AuditEvent[];
};

type SaleRequestEditDraft = {
    seller: Seller;
    right: RightInfo;
    desired_price: number | null;
    sale_method: string;
    privacy_consent: boolean;
    fee_consent: boolean;
    admin_service_requested: boolean;
    description: string;
};

type Pagination = {
    page: number;
    limit: number;
    total: number;
    total_pages: number;
};

type PublishResult = {
    listing_id: string;
    listing_status: string;
    reused: boolean;
};

@Component({
    selector: 'wiz-page-ip-market-applications',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ip.market.applications/view.scss */
:host {
  display: block;
  height: 100%;
}

.ipt-review-detail-page {
  width: 100%;
  min-width: 0;
  overflow: clip !important;
}

.ipt-detail-page__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #dce8ea;
  background: #f7fbfb;
}

.ipt-detail-page__eyebrow {
  color: #0e7b8d;
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.14em;
}

.ipt-detail-page__header h1 {
  margin-top: 0.3rem;
  color: #17323a;
  font-size: 1.25rem;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.025em;
}

.ipt-detail-page__description {
  margin-top: 0.35rem;
  color: #647b83;
  font-size: 0.72rem;
  line-height: 1.5;
}

.ipt-detail-page__header > button {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 2.5rem;
  padding: 0.55rem 0.9rem;
  border: 1px solid #bfd3d7;
  border-radius: 0.6rem;
  color: #315961;
  background: #fff;
  font-size: 0.75rem;
  font-weight: 800;
  transition: border-color 150ms ease, background-color 150ms ease, color 150ms ease;
}

.ipt-detail-page__header > button:hover:not(:disabled) {
  border-color: #58aeb9;
  color: #086779;
  background: #effafa;
}

.ipt-detail-page__header > button:focus-visible {
  outline: 3px solid rgba(6, 182, 212, 0.18);
  outline-offset: 2px;
}

.ipt-detail-page__header > button:disabled {
  cursor: wait;
  opacity: 0.5;
}

.ipt-detail-loading {
  display: flex;
  min-height: 15rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1.25rem;
  text-align: center;
}

.ipt-detail-loading__icon {
  color: #0e7b8d;
  font-size: 1.75rem;
}

.ipt-detail-loading p {
  margin-top: 0.9rem;
  color: #315961;
  font-size: 0.82rem;
  font-weight: 800;
}

.ipt-detail-loading span {
  margin-top: 0.35rem;
  color: #7a9097;
  font-size: 0.68rem;
  line-height: 1.5;
}

.ipt-review-summary__actions--delete {
  width: min(21.25rem, 42vw);
}

.ipt-review-summary__actions > span:first-child {
  align-self: flex-end;
}

.ipt-delete-request-card {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #fecdd3;
  border-radius: 0.625rem;
  text-align: left;
  background: #fff1f2;
}

.ipt-delete-request-card h3 {
  color: #9f1239;
  font-size: 0.6875rem;
  font-weight: 800;
  line-height: 1.4;
}

.ipt-delete-request-card > p {
  margin-top: 0.25rem;
  color: #be123c;
  font-size: 0.625rem;
  line-height: 1.5;
}

.ipt-delete-request-card__action {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.625rem;
}

.ipt-delete-request-card__action button {
  display: inline-flex;
  min-width: 6.5rem;
  min-height: 2rem;
  align-items: center;
  justify-content: center;
  padding: 0.4rem 0.75rem;
  border-radius: 0.5rem;
  color: #fff;
  background: #e11d48;
  font-size: 0.6875rem;
  font-weight: 800;
}

.ipt-delete-request-card__action button:hover:not(:disabled) {
  background: #be123c;
}

.ipt-delete-request-card__action button:disabled {
  cursor: not-allowed;
  background: #fda4af;
}

.ipt-delete-request-card .ipt-delete-request-card__state {
  margin-top: 0.625rem;
  padding-top: 0.5rem;
  border-top: 1px solid #fecdd3;
}

.ipt-create-sale-button {
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  min-width: 9.65rem;
  min-height: 3.25rem;
  padding: 0.45rem 0.85rem 0.45rem 0.5rem;
  border-radius: 0.75rem;
  text-align: left;
  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.ipt-create-sale-button:hover:not(:disabled) {
  border-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 10px 24px rgba(4, 44, 54, 0.2);
  transform: translateY(-1px);
}

.ipt-create-sale-button:focus-visible {
  outline: 3px solid rgba(131, 227, 228, 0.55);
  outline-offset: 3px;
}

.ipt-create-sale-button__icon {
  display: inline-grid;
  flex: 0 0 auto;
  width: 2.15rem;
  height: 2.15rem;
  place-items: center;
  border-radius: 0.58rem;
  color: #fff;
  background: #087184;
  font-size: 0.72rem;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.16);
}

.ipt-create-sale-button__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.12rem;
}

.ipt-create-sale-button__copy strong {
  color: #07586a;
  font-size: 0.78rem;
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.02em;
}

.ipt-create-sale-button__copy small {
  color: #4f7d86;
  font-size: 0.62rem;
  font-weight: 700;
  line-height: 1.15;
}

@media (max-width: 47.99rem) {
  .ipt-detail-page__header {
    align-items: flex-start;
    padding: 1rem;
  }
  .ipt-review-summary--delete {
    flex-direction: column;
  }
  .ipt-review-summary__actions--delete {
    width: 100%;
    align-items: stretch;
  }
  .ipt-review-summary__actions > span:first-child {
    align-self: flex-end;
  }
  .ipt-detail-page__description {
    max-width: 15rem;
  }
  .ipt-detail-page__header > button {
    padding-inline: 0.75rem;
  }
  .ipt-create-sale-button {
    width: 100%;
  }
}
.ipt-phone-input {
  display: grid;
  grid-template-columns: minmax(4.6rem, 0.8fr) auto minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 0.3rem;
  width: 100%;
  min-height: 2.25rem;
  margin-top: 0.25rem;
  padding: 0 0.55rem;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  color: #1e293b;
  background: #fff;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.ipt-phone-input:focus-within {
  border-color: #06b6d4;
  box-shadow: 0 0 0 3px rgba(6, 182, 212, 0.12);
}

.ipt-phone-input > select,
.ipt-phone-input > input {
  min-width: 0;
  height: 2.1rem;
  border: 0;
  color: #1e293b;
  background: transparent;
  font-size: 0.75rem;
  font-weight: 600;
  outline: none;
}

.ipt-phone-input > select {
  width: 100%;
  padding-right: 1.35rem;
  cursor: pointer;
}

.ipt-phone-input > input {
  width: 100%;
  padding: 0 0.2rem;
  text-align: center;
  letter-spacing: 0.04em;
}

.ipt-phone-input > input::placeholder {
  color: #94a3b8;
  font-weight: 500;
  letter-spacing: 0;
}

.ipt-phone-input > span {
  color: #94a3b8;
  font-size: 0.72rem;
  font-weight: 700;
}

.ipt-phone-input:has(> select:disabled) {
  cursor: not-allowed;
  background: #f8fafc;
  opacity: 0.65;
}

.ipt-email-input {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1.25fr);
  align-items: center;
  gap: 0.55rem;
  width: 100%;
  min-height: 2.25rem;
  margin-top: 0.25rem;
  padding: 0 0.75rem;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  color: #1e293b;
  background: #fff;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.ipt-email-input:focus-within {
  border-color: #06b6d4;
  box-shadow: 0 0 0 3px rgba(6, 182, 212, 0.12);
}

.ipt-email-input > input {
  min-width: 0;
  width: 100%;
  height: 2.1rem;
  padding: 0;
  border: 0;
  color: #1e293b;
  background: transparent;
  font-size: 0.75rem;
  font-weight: 600;
  outline: none;
}

.ipt-email-input > input:first-child {
  text-align: right;
}

.ipt-email-input > input::placeholder {
  color: #94a3b8;
  font-weight: 500;
}

.ipt-email-input > span {
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 800;
}

.ipt-email-input:has(> input:disabled) {
  cursor: not-allowed;
  background: #f8fafc;
  opacity: 0.65;
}

.ipt-page--applications .ipt-container.ipt-container--detail {
  max-width: 96rem !important;
}

.ipt-detail-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.55rem;
  padding: 0.75rem 1.5rem;
  overflow-x: auto;
  border-bottom: 1px solid #dce8ea;
  background: #fbfdfd;
}

.ipt-detail-tabs button {
  display: flex;
  min-width: 0;
  min-height: 3.35rem;
  align-items: center;
  gap: 0.7rem;
  padding: 0.65rem 0.85rem;
  border: 1px solid #d7e4e7;
  border-radius: 0.65rem;
  color: #647b83;
  text-align: left;
  background: #fff;
  transition: border-color 150ms ease, background-color 150ms ease, color 150ms ease, box-shadow 150ms ease;
}

.ipt-detail-tabs button:hover:not(.is-active) {
  border-color: #9bc6cc;
  color: #315961;
  background: #f4fafb;
}

.ipt-detail-tabs button:focus-visible {
  outline: 3px solid rgba(6, 182, 212, 0.2);
  outline-offset: 2px;
}

.ipt-detail-tabs button.is-active {
  border-color: #0e7b8d;
  color: #075f70;
  background: #edf8f9;
  box-shadow: inset 0 -2px 0 #0e7b8d;
}

.ipt-detail-tabs button > i {
  display: grid;
  flex: 0 0 auto;
  width: 2rem;
  height: 2rem;
  place-items: center;
  border-radius: 0.5rem;
  color: #6f8a91;
  background: #f0f5f6;
  font-size: 0.78rem;
}

.ipt-detail-tabs button.is-active > i {
  color: #fff;
  background: #0e7b8d;
}

.ipt-detail-tabs button > span {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.12rem;
}

.ipt-detail-tabs strong {
  overflow: hidden;
  color: inherit;
  font-size: 0.75rem;
  font-weight: 800;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ipt-detail-tabs small {
  overflow: hidden;
  color: #7a9097;
  font-size: 0.625rem;
  font-weight: 600;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ipt-detail-tab-panel {
  min-height: 18rem;
}

.ipt-tab-empty-state {
  display: flex;
  min-height: 16rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1.25rem;
  border: 1px dashed #cbdde0;
  border-radius: 0.75rem;
  color: #6a8188;
  text-align: center;
  background: #f8fbfb;
}

.ipt-tab-empty-state i {
  color: #6eaab3;
  font-size: 1.45rem;
}

.ipt-tab-empty-state h3 {
  margin-top: 0.8rem;
  color: #315961;
  font-size: 0.8rem;
  font-weight: 800;
}

.ipt-tab-empty-state p {
  max-width: 27rem;
  margin-top: 0.35rem;
  font-size: 0.68rem;
  line-height: 1.6;
}

@media (max-width: 47.99rem) {
  .ipt-detail-tabs {
    display: flex;
    padding: 0.7rem 1rem;
    scroll-snap-type: x proximity;
  }
  .ipt-detail-tabs button {
    flex: 0 0 12.5rem;
    scroll-snap-align: start;
  }
  .ipt-detail-tab-panel {
    min-height: 14rem;
  }
}`],
})
export class PageIpMarketApplicationsComponent implements OnInit, OnDestroy {
    public statuses: SaleRequestStatus[] = [
        'SUBMITTED',
        'IN_REVIEW',
        'NEEDS_REVISION',
        'APPROVED',
        'REJECTED',
        'PUBLISHED',
        'CANCELLED'
    ];
    public requestTypes: SaleRequestType[] = ['CREATE', 'UPDATE', 'DELETE'];
    public rightTypeTabs: any[] = [
        { value: 'PATENT', label: '특허/실용' },
        { value: 'TRADEMARK', label: '상표' },
        { value: 'DESIGN', label: '디자인' }
    ];
    public technicalFieldOptions: string[] = [
        '전기·전자·통신',
        '화학·환경·소재',
        '기계·건축·토목',
        '바이오·의료',
        '로봇·반도체',
        '생활발명'
    ];
    public mobilePhonePrefixes: string[] = ['010', '011', '016', '017', '018', '019'];
    public filters: any = {
        status: '',
        request_type: '',
        assigned_to: '',
        assisted_only: '',
        q: '',
        page: 1,
        limit: 10
    };
    public items: SaleRequestListItem[] = [];
    public pagination: Pagination = { page: 1, limit: 10, total: 0, total_pages: 1 };
    public selected: SaleRequestDetail | null = null;
    public editDraft: SaleRequestEditDraft = this.emptyDraft();
    public createDraft: SaleRequestEditDraft = this.emptyDraft(true);
    public loading: boolean = false;
    public listLoaded: boolean = false;
    public detailLoading: boolean = false;
    public detailLoadAttempted: boolean = false;
    public saving: boolean = false;
    public editing: boolean = false;
    public approving: boolean = false;
    public uploading: boolean = false;
    public uploadProgress: number = 0;
    public deletingFileId: string = '';
    public deletingSale: boolean = false;
    public publishing: boolean = false;
    public createOpen: boolean = false;
    public creating: boolean = false;
    public createImages: File[] = [];
    public createUploadProgress: number = 0;
    public createIdempotencyKey: string = '';
    public createPayloadSnapshot: string = '';
    public createPhone: { prefix: string; middle: string; last: string } = {
        prefix: '010',
        middle: '',
        last: ''
    };
    public createEmail: { local: string; domain: string } = {
        local: '',
        domain: ''
    };
    public publishResult: PublishResult | null = null;
    public errorMessage: string = '';
    public assigneeDraft: string = '';
    public messageDraft: string = '';
    public workflowReasonDraft: string = '';
    public revisionComposerOpen: boolean = false;
    public activeDetailId: string = '';
    public detailTab: 'overview' | 'documents' | 'operations' = 'overview';
    private routeSubscription: Subscription = null;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        this.activeDetailId = this.requestIdFromLocation();
        this.detailLoading = !!this.activeDetailId;

        await this.service.init();
        await this.service.auth.allow('/access');

        if (this.activeDetailId) {
            this.detailLoading = false;
            await this.loadDetail(this.activeDetailId);
        } else {
            await this.load();
        }

        this.routeSubscription = this.router.events.subscribe(async (event) => {
            if (!(event instanceof NavigationEnd)) return;
            await this.syncDetailFromLocation();
            await this.service.render();
            this.scrollWorkspaceTop();
        });
    }

    public ngOnDestroy() {
        this.routeSubscription?.unsubscribe();
    }

    private normalizedListFilters(resetPage: boolean = false) {
        const status = this.statuses.includes(this.filters.status)
            ? this.filters.status
            : '';
        const requestType = this.requestTypes.includes(this.filters.request_type)
            ? this.filters.request_type
            : '';
        const assistedOnly = this.filters.assisted_only === 'true' ? 'true' : '';
        const currentPage = Number(this.filters.page);
        return {
            q: String(this.filters.q || '').trim(),
            status,
            request_type: requestType,
            assisted_only: assistedOnly,
            assigned_to: String(this.filters.assigned_to || '').trim(),
            page: resetPage || !Number.isFinite(currentPage) || currentPage < 1
                ? 1
                : Math.floor(currentPage),
            limit: 10
        };
    }

    public async load(resetPage: boolean = false) {
        if (this.loading) return;
        const requestFilters = this.normalizedListFilters(resetPage);
        this.filters = { ...this.filters, ...requestFilters };

        const previousId = this.selected?.id || '';
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            const response = await wiz.call('list_sale_requests', requestFilters);
            if (response.code !== 200) {
                throw new Error(this.responseError(response, '판매 요청 목록을 불러오지 못했습니다.'));
            }
            const data = response.data || {};
            this.items = Array.isArray(data.items)
                ? data.items.map((item: any) => this.normalizeListItem(item))
                : [];
            this.pagination = data.pagination || {
                page: this.filters.page,
                limit: this.filters.limit,
                total: this.items.length,
                total_pages: 1
            };
            this.filters.page = this.pagination.page || 1;
            this.listLoaded = true;

            const next = previousId
                ? this.items.find((item) => item.id === previousId)
                : null;
            if (next) {
                await this.loadDetail(next.id, false);
            } else {
                this.selected = null;
                this.editing = false;
            }
        } catch (error) {
            this.items = [];
            this.selected = null;
            this.editing = false;
            this.errorMessage = this.errorText(error, '판매 요청 목록을 불러오지 못했습니다.');
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async loadDetail(id: string, render: boolean = true) {
        if (!id || this.detailLoading) return;
        if (this.selected?.id !== id) {
            this.publishResult = null;
            this.detailTab = 'overview';
        }
        this.detailLoadAttempted = false;
        this.detailLoading = true;
        this.errorMessage = '';
        this.editing = false;
        if (render) await this.service.render();

        try {
            const response = await wiz.call('get_sale_request', { id });
            if (response.code !== 200) {
                throw new Error(this.responseError(response, '판매 요청 상세를 불러오지 못했습니다.'));
            }
            this.applyDetail(response.data as SaleRequestDetail);
            this.updateListItem(this.selected);
            this.refreshPublishedListing(id);
        } catch (error) {
            this.selected = null;
            this.errorMessage = this.errorText(error, '판매 요청 상세를 불러오지 못했습니다.');
            if (render) await this.service.modal.error(this.errorMessage);
        } finally {
            this.detailLoadAttempted = true;
            this.detailLoading = false;
            if (render) await this.service.render();
        }
    }

    public async openDetailPage(id: string) {
        if (!id || this.detailLoading) return;
        await this.router.navigate(['/ip-market/applications'], {
            queryParams: { request: id },
            queryParamsHandling: 'merge'
        });
    }

    public async closeDetail() {
        if (this.detailLoading || this.saving || this.approving || this.uploading || this.publishing || this.deletingSale || this.deletingFileId) return;
        const shouldLoadList = !this.listLoaded;
        this.activeDetailId = '';
        this.detailTab = 'overview';
        this.selected = null;
        this.editing = false;
        this.publishResult = null;
        this.detailLoadAttempted = false;
        await this.router.navigate(['/ip-market/applications'], {
            queryParams: { request: null },
            queryParamsHandling: 'merge'
        });
        if (shouldLoadList) await this.load();
    }

    private async syncDetailFromLocation() {
        const requestId = this.requestIdFromLocation();
        this.activeDetailId = requestId;

        if (!requestId) {
            this.selected = null;
            this.editing = false;
            this.publishResult = null;
            this.detailLoadAttempted = false;
            return;
        }

        if (this.selected?.id === requestId) return;
        this.detailLoadAttempted = false;
        await this.loadDetail(requestId);
    }

    private requestIdFromLocation() {
        if (typeof location === 'undefined') return '';
        return new URLSearchParams(location.search).get('request') || '';
    }

    private scrollWorkspaceTop() {
        if (typeof document === 'undefined') return;
        document.querySelector('.wb-route-stage')?.scrollTo({
            top: 0,
            behavior: 'instant' as ScrollBehavior
        });
    }

    public async setDetailTab(tab: 'overview' | 'documents' | 'operations') {
        if (this.detailTab === tab) return;
        this.detailTab = tab;
        this.revisionComposerOpen = false;
        this.workflowReasonDraft = '';
        await this.service.render();
    }

    public async openCreate() {
        if (this.creating) return;
        this.createDraft = this.emptyDraft(true);
        this.resetCreatePhone();
        this.resetCreateEmail();
        this.createImages = [];
        this.createUploadProgress = 0;
        this.createIdempotencyKey = '';
        this.createPayloadSnapshot = '';
        this.createOpen = true;
        this.errorMessage = '';
        await this.service.render();
    }

    public async closeCreate() {
        if (this.creating) return;
        this.createOpen = false;
        this.createImages = [];
        this.createUploadProgress = 0;
        this.createIdempotencyKey = '';
        this.createPayloadSnapshot = '';
        await this.service.render();
    }

    public updateCreatePhonePrefix(value: string) {
        const prefix = String(value || '');
        this.createPhone.prefix = this.mobilePhonePrefixes.includes(prefix) ? prefix : '010';
        this.syncCreatePhone();
    }

    public updateCreatePhonePart(part: 'middle' | 'last', value: string) {
        this.createPhone[part] = String(value || '').replace(/\D/g, '').slice(0, 4);
        this.syncCreatePhone();
    }

    public createPhonePreview() {
        const { prefix, middle, last } = this.createPhone;
        if (!middle && !last) return '';
        return prefix + '-' + middle + '-' + last;
    }

    public updateCreateEmailPart(part: 'local' | 'domain', value: string) {
        const normalized = String(value || '').replace(/[\s@]/g, '');
        this.createEmail[part] = part === 'domain'
            ? normalized.toLowerCase().slice(0, 189)
            : normalized.slice(0, 64);
        this.syncCreateEmail();
    }

    public createEmailPreview() {
        const { local, domain } = this.createEmail;
        if (!local && !domain) return '';
        return local + '@' + domain;
    }

    public async selectRightType(value: string) {
        if (this.creating) return;
        this.createDraft.right.right_type = value;
        await this.service.render();
    }

    public rightTypeTabActive(value: string) {
        if (value === 'PATENT') {
            return ['PATENT', 'UTILITY_MODEL'].includes(this.createDraft.right.right_type);
        }
        return this.createDraft.right.right_type === value;
    }

    public rightTitleLabel() {
        switch (this.createDraft.right.right_type) {
            case 'TRADEMARK': return '상표의 명칭';
            case 'DESIGN': return '디자인의 명칭';
            default: return '발명(고안)의 명칭';
        }
    }

    public async toggleTechnicalField(value: string) {
        if (this.creating) return;
        const current = this.createDraft.right.technical_fields || [];
        if (current.includes(value)) {
            this.createDraft.right.technical_fields = current.filter((item) => item !== value);
        } else if (current.length >= 2) {
            await this.service.modal.error('기술분야는 최대 2개까지 선택할 수 있습니다.');
            return;
        } else {
            this.createDraft.right.technical_fields = [...current, value];
        }
        this.createDraft.right.field = this.createDraft.right.technical_fields.join(' · ');
        await this.service.render();
    }

    public technicalFieldSelected(value: string) {
        return (this.createDraft.right.technical_fields || []).includes(value);
    }

    public async selectCreateImages(event: any) {
        const input = event?.target as HTMLInputElement;
        const selected = input?.files ? Array.from(input.files) as File[] : [];
        if (input) input.value = '';
        if (!selected.length || this.creating) return;

        const next = [...this.createImages];
        for (const file of selected) {
            const validation = this.validateCreateImage(file);
            if (validation) {
                await this.service.modal.error(validation);
                return;
            }
            if (next.length >= 3) {
                await this.service.modal.error('탑재 이미지는 최대 3개까지 선택할 수 있습니다.');
                return;
            }
            if (!next.some((item) => item.name === file.name && item.size === file.size)) next.push(file);
        }
        this.createImages = next;
        await this.service.render();
    }

    public async removeCreateImage(index: number) {
        if (this.creating) return;
        this.createImages = this.createImages.filter((_file, fileIndex) => fileIndex !== index);
        await this.service.render();
    }

    public async createPublished() {
        if (!this.createOpen || this.creating) return;
        const validation = this.validateDraft(this.createDraft, true);
        if (validation) {
            await this.service.modal.error(validation);
            return;
        }
        if (!this.createDraft.privacy_consent || !this.createDraft.fee_consent) {
            await this.service.modal.error('판매자의 개인정보 처리 및 수수료 안내 동의를 모두 확인해주세요.');
            return;
        }

        const confirmed = await this.service.modal.show({
            title: '관리자 판매등록',
            message: '저장과 동시에 공개매물로 게시됩니다. 입력 내용을 확인했나요?',
            action: '등록 및 공개',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'success'
        });
        if (!confirmed) return;

        this.creating = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const serializedPayload = JSON.stringify(this.createDraft);
            if (!this.createIdempotencyKey || this.createPayloadSnapshot !== serializedPayload) {
                this.createIdempotencyKey = this.service.random(32);
                this.createPayloadSnapshot = serializedPayload;
            }
            const response = await wiz.call('create_published_sale_request', {
                payload: serializedPayload,
                idempotency_key: this.createIdempotencyKey
            });
            if (response.code !== 200 && response.code !== 201) {
                throw new Error(this.responseError(response, '관리자 판매등록에 실패했습니다.'));
            }
            const data = response.data || {};
            const saleRequest = data.sale_request || {};
            const listing = data.listing || {};
            const saleRequestId = saleRequest.id || '';
            if (!saleRequestId || !listing.id) {
                throw new Error('공개된 판매요청 정보를 확인할 수 없습니다.');
            }

            const failedImages: string[] = [];
            this.createUploadProgress = 0;
            for (let index = 0; index < this.createImages.length; index += 1) {
                const file = this.createImages[index];
                try {
                    const form = new FormData();
                    form.append('id', saleRequestId);
                    form.append('file', file);
                    const uploadResponse: any = await this.service.file.upload(
                        wiz.url('upload_sale_request_file'),
                        form,
                        async (percent: number) => {
                            this.createUploadProgress = Math.round(
                                ((index + percent / 100) / this.createImages.length) * 100
                            );
                            await this.service.render();
                        }
                    );
                    this.uploadResponseData(uploadResponse);
                } catch (_error) {
                    failedImages.push(file.name);
                }
            }

            if (this.createImages.length && failedImages.length < this.createImages.length) {
                const refreshResponse = await wiz.call('publish_sale_request', { id: saleRequestId });
                if (refreshResponse.code !== 200 && refreshResponse.code !== 201) {
                    failedImages.push('공개매물 이미지 갱신');
                }
            }

            this.createOpen = false;
            this.createImages = [];
            this.createUploadProgress = 0;
            this.createIdempotencyKey = '';
            this.createPayloadSnapshot = '';
            this.filters.page = 1;
            await this.load();
            await this.loadDetail(saleRequestId, false);
            this.publishResult = {
                listing_id: listing.id,
                listing_status: listing.status || 'PUBLISHED',
                reused: false
            };
            if (failedImages.length) {
                await this.service.modal.warning(
                    '판매등록은 공개되었습니다. 업로드하지 못한 자료는 상세 화면에서 다시 탑재해주세요: '
                    + failedImages.join(', ')
                );
            } else {
                await this.service.modal.success('관리자 판매등록과 공개매물 게시가 완료되었습니다.');
            }
        } catch (error) {
            this.errorMessage = this.errorText(error, '관리자 판매등록에 실패했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.creating = false;
            this.createUploadProgress = 0;
            await this.service.render();
        }
    }

    public async startEdit() {
        if (!this.selected || this.saving) return;
        this.editDraft = this.draftFromDetail(this.selected);
        this.detailTab = 'overview';
        this.revisionComposerOpen = false;
        this.workflowReasonDraft = '';
        this.editing = true;
        await this.service.render();
    }

    public isAssistedRequest(item: SaleRequestListItem | SaleRequestDetail | null) {
        return !!item?.admin_service_requested
            && !item?.created_by_admin
            && item?.submission_channel !== 'ADMIN';
    }

    public canStartReview(status: SaleRequestStatus) {
        return ['SUBMITTED', 'NEEDS_REVISION'].includes(status);
    }

    public async startReview() {
        if (!this.selected || !this.isAssistedRequest(this.selected) || !this.canStartReview(this.selected.status)) return;
        await this.mutate(
            'update_sale_request_status',
            { id: this.selected.id, status: 'IN_REVIEW', reason: '판매등록 대행 검수 시작' },
            '판매등록 대행 검수를 시작했습니다.',
            '검수 시작 처리에 실패했습니다.'
        );
    }

    public async requestRevision() {
        if (!this.selected || !this.isAssistedRequest(this.selected) || this.saving) return;
        const reason = this.workflowReasonDraft.trim();
        if (!reason) {
            await this.service.modal.error('부족한 자료와 보완 요청 내용을 입력해주세요.');
            return;
        }
        await this.mutate(
            'update_sale_request_status',
            { id: this.selected.id, status: 'NEEDS_REVISION', reason: '자료 보완 요청: ' + reason },
            '판매자에게 자료 보완이 필요한 상태로 처리했습니다.',
            '자료 보완 요청 처리에 실패했습니다.'
        );
        this.workflowReasonDraft = '';
        this.revisionComposerOpen = false;
    }

    public async openRevisionComposer() {
        if (!this.selected || !this.isAssistedRequest(this.selected) || this.saving) return;
        this.workflowReasonDraft = '';
        this.revisionComposerOpen = true;
        await this.service.render();
    }

    public async closeRevisionComposer() {
        if (this.saving) return;
        this.workflowReasonDraft = '';
        this.revisionComposerOpen = false;
        await this.service.render();
    }

    public async waitSellerConfirmation() {
        if (!this.selected || !this.isAssistedRequest(this.selected) || this.saving) return;
        const note = this.workflowReasonDraft.trim();
        if (!note) {
            await this.service.modal.error('판매자에게 확인받을 내용을 입력해주세요.');
            return;
        }
        await this.mutate(
            'update_sale_request_status',
            { id: this.selected.id, status: 'NEEDS_REVISION', reason: '판매자 확인 대기: ' + note },
            '판매자 확인 대기 상태로 처리했습니다.',
            '판매자 확인 대기 처리에 실패했습니다.'
        );
        this.workflowReasonDraft = '';
    }

    public async approveAndPublish() {
        if (!this.selected || !this.isAssistedRequest(this.selected) || this.approving || this.publishing) return;
        if (!['SUBMITTED', 'IN_REVIEW', 'NEEDS_REVISION', 'APPROVED'].includes(this.selected.status)) {
            await this.service.modal.error('검수 중이거나 승인된 대행 요청만 최종 공개할 수 있습니다.');
            return;
        }
        const confirmed = await this.service.modal.show({
            title: '판매등록 대행 최종 승인 및 공개',
            message: '판매정보, 첨부자료와 판매자 확인 내용을 모두 검토했나요? 승인 직후 공개매물로 게시됩니다.',
            action: '승인 및 공개',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'success'
        });
        if (!confirmed) return;

        const id = this.selected.id;
        this.approving = true;
        this.publishing = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            if (this.selected.status !== 'APPROVED') {
                const approval = await wiz.call('approve_sale_request', {
                    id,
                    reason: '판매등록 대행 최종 승인'
                });
                if (approval.code !== 200) {
                    throw new Error(this.responseError(approval, '판매등록 대행 승인에 실패했습니다.'));
                }
            }
            const publication = await wiz.call('publish_sale_request', { id });
            if (publication.code !== 200 && publication.code !== 201) {
                throw new Error(this.responseError(publication, '판매등록 대행 공개에 실패했습니다.'));
            }
            await this.loadDetail(id, false);
            await this.service.modal.success('판매등록 대행 요청을 최종 승인하고 공개했습니다.');
        } catch (error) {
            this.errorMessage = this.errorText(error, '최종 승인 및 공개에 실패했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.approving = false;
            this.publishing = false;
            await this.service.render();
        }
    }

    public async cancelEdit() {
        if (!this.selected || this.saving) return;
        this.editDraft = this.draftFromDetail(this.selected);
        this.editing = false;
        this.revisionComposerOpen = false;
        await this.service.render();
    }

    public async saveEdit() {
        if (!this.selected || !this.editing || this.saving) return;
        const assisted = this.isAssistedRequest(this.selected);
        const validation = this.validateDraft(this.editDraft);
        if (validation) {
            await this.service.modal.error(validation);
            return;
        }

        const id = this.selected.id;
        this.saving = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('update_sale_request', {
                id,
                payload: JSON.stringify(this.editDraft)
            });
            if (response.code !== 200) {
                throw new Error(this.responseError(response, '판매 요청 저장에 실패했습니다.'));
            }
            await this.loadDetail(id, false);
            this.editing = false;
            await this.service.modal.success(
                assisted ? '판매정보 작성 내용을 저장했습니다.' : '판매 요청 정보를 저장했습니다.'
            );
        } catch (error) {
            this.errorMessage = this.errorText(error, '판매 요청 저장에 실패했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public canApprove(status: SaleRequestStatus) {
        return ['SUBMITTED', 'IN_REVIEW', 'NEEDS_REVISION'].includes(status);
    }

    public isDeleteRequest(item: SaleRequestListItem | SaleRequestDetail | null) {
        return item?.request_type === 'DELETE';
    }

    public canProcessDelete(item: SaleRequestListItem | SaleRequestDetail | null) {
        return this.isDeleteRequest(item)
            && !!item
            && ['SUBMITTED', 'IN_REVIEW', 'NEEDS_REVISION'].includes(item.status);
    }

    public async deleteRequestedSale() {
        if (!this.selected || !this.canProcessDelete(this.selected) || this.deletingSale) return;
        const confirmed = await this.service.modal.show({
            title: '판매 종료 요청 승인',
            message: '승인하면 해당 판매의 공개가 종료되며, 공개매물 목록에서 더 이상 노출되지 않습니다. 매물 데이터는 물리적으로 삭제되지 않습니다.',
            action: '판매 종료 승인',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'error'
        });
        if (!confirmed) return;

        const id = this.selected.id;
        this.deletingSale = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('delete_requested_sale', { id });
            if (response.code !== 200) {
                throw new Error(this.responseError(
                    response,
                    '판매 삭제 요청 처리에 실패했습니다.',
                    true
                ));
            }

            const result = response.data || {};
            const updatedRequest = this.normalizeDetail({
                ...this.selected,
                ...(result.sale_request || {})
            });
            this.applyDetail(updatedRequest);
            this.updateListItem(updatedRequest);
            if (result.listing?.id) {
                this.publishResult = {
                    listing_id: result.listing.id,
                    listing_status: result.listing.status || 'ENDED',
                    reused: result.already_approved === true
                };
            }

            await this.load(true);
            if (this.selected?.id !== id) {
                await this.loadDetail(id, false);
            }
            await this.service.modal.success('판매 공개를 종료하고 삭제 요청을 처리 완료했습니다.');
        } catch (error) {
            this.errorMessage = this.errorText(
                error,
                '판매 삭제 요청 처리에 실패했습니다.',
                true
            );
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.deletingSale = false;
            await this.service.render();
        }
    }

    public async approve() {
        if (!this.selected || this.approving || !this.canApprove(this.selected.status)) return;
        const confirmed = await this.service.modal.show({
            title: '판매 요청 최종 승인',
            message: '수정 내용과 탑재 서류를 모두 확인했나요? 승인 후 공개 listing 게시를 진행할 수 있습니다.',
            action: '최종 승인',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'success'
        });
        if (!confirmed) return;

        const id = this.selected.id;
        this.approving = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('approve_sale_request', {
                id,
                reason: '관리자 최종 승인'
            });
            if (response.code !== 200) {
                throw new Error(this.responseError(response, '판매 요청 승인에 실패했습니다.'));
            }
            await this.loadDetail(id, false);
            await this.service.modal.success('판매 요청을 최종 승인했습니다.');
        } catch (error) {
            this.errorMessage = this.errorText(error, '판매 요청 승인에 실패했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.approving = false;
            await this.service.render();
        }
    }

    public canPublish(status: SaleRequestStatus) {
        return ['APPROVED', 'PUBLISHED'].includes(status);
    }

    public async publish() {
        if (!this.selected || this.publishing) return;
        if (!this.canPublish(this.selected.status)) {
            await this.service.modal.error('최종 승인 후 공개 listing을 게시할 수 있습니다.');
            return;
        }

        const id = this.selected.id;
        const alreadyPublished = this.selected.status === 'PUBLISHED' || !!this.selected.target_sale_id;
        this.publishing = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            const response = await wiz.call('publish_sale_request', { id });
            if (response.code !== 200 && response.code !== 201) {
                throw new Error(this.responseError(response, '공개 listing 게시에 실패했습니다.'));
            }
            const data = response.data || {};
            const listing = data.listing || {};
            const saleRequest = data.sale_request || data.saleRequest || {};
            const listingId = listing.id
                || data.listing_id
                || data.id
                || saleRequest.target_sale_id
                || this.selected.target_sale_id
                || '';
            const listingStatus = listing.status || data.listing_status || data.status || 'PUBLISHED';
            const reused = data.created === false || data.updated === true || alreadyPublished;

            await this.loadDetail(id, false);
            this.publishResult = {
                listing_id: listingId || this.selected?.target_sale_id || '',
                listing_status: listingStatus,
                reused
            };
            await this.service.modal.success(
                reused
                    ? '기존 공개 listing을 최신 판매 요청 정보로 갱신했습니다.'
                    : '판매 요청을 공개 listing으로 게시했습니다.'
            );
        } catch (error) {
            this.errorMessage = this.errorText(error, '공개 listing 게시에 실패했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.publishing = false;
            await this.service.render();
        }
    }

    public async uploadDocuments(event: any) {
        const input = event?.target as HTMLInputElement;
        const files = input?.files ? Array.from(input.files) as File[] : [];
        if (input) input.value = '';
        if (!this.selected || !files.length || this.uploading) return;

        for (const file of files) {
            const validation = this.validateDocument(file);
            if (validation) {
                await this.service.modal.error(validation);
                return;
            }
        }

        const id = this.selected.id;
        this.uploading = true;
        this.uploadProgress = 0;
        this.errorMessage = '';
        await this.service.render();
        try {
            for (let index = 0; index < files.length; index += 1) {
                const form = new FormData();
                form.append('id', id);
                form.append('file', files[index]);
                const response: any = await this.service.file.upload(
                    wiz.url('upload_sale_request_file'),
                    form,
                    async (percent: number) => {
                        this.uploadProgress = Math.round(((index + percent / 100) / files.length) * 100);
                        await this.service.render();
                    }
                );
                this.uploadResponseData(response);
            }
            await this.loadDetail(id, false);
            await this.service.modal.success(files.length + '개 서류를 탑재했습니다.');
        } catch (error) {
            this.errorMessage = this.uploadErrorText(error, '서류 탑재에 실패했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.uploading = false;
            this.uploadProgress = 0;
            await this.service.render();
        }
    }

    public async deleteDocument(file: SaleFile) {
        if (!this.selected || !file?.id || this.deletingFileId) return;
        const confirmed = await this.service.modal.show({
            title: '탑재 서류 삭제',
            message: (file.file_name || '선택한 서류') + '을(를) 삭제할까요?',
            action: '삭제',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'error'
        });
        if (!confirmed) return;

        const id = this.selected.id;
        this.deletingFileId = file.id;
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('delete_sale_request_file', {
                id,
                file_id: file.id
            });
            if (response.code !== 200 && response.code !== 204) {
                throw new Error(this.responseError(response, '서류 삭제에 실패했습니다.'));
            }
            await this.loadDetail(id, false);
            await this.service.modal.success('탑재 서류를 삭제했습니다.');
        } catch (error) {
            this.errorMessage = this.errorText(error, '서류 삭제에 실패했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.deletingFileId = '';
            await this.service.render();
        }
    }

    public downloadDocument(file: SaleFile) {
        if (!this.selected?.id || !file?.id) return;
        const query = new URLSearchParams({
            id: this.selected.id,
            file_id: file.id
        });
        window.open(
            wiz.url('download_sale_request_file') + '?' + query.toString(),
            '_blank',
            'noopener,noreferrer'
        );
    }

    public async assign() {
        if (!this.selected || this.saving) return;
        const assignee = this.assigneeDraft.trim();
        if (!assignee) {
            await this.service.modal.error('담당자 식별자를 입력해주세요.');
            return;
        }
        await this.mutate(
            'assign_sale_request',
            { id: this.selected.id, assignee },
            '담당자가 배정되었습니다.',
            '담당자 배정에 실패했습니다.'
        );
    }

    public async addMessage() {
        if (!this.selected || this.saving) return;
        const body = this.messageDraft.trim();
        if (!body) {
            await this.service.modal.error('내부 메시지 내용을 입력해주세요.');
            return;
        }

        this.saving = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const id = this.selected.id;
            const response = await wiz.call('add_sale_request_message', { id, body });
            if (response.code !== 201) {
                throw new Error(this.responseError(response, '내부 메시지 추가에 실패했습니다.'));
            }
            this.messageDraft = '';
            await this.loadDetail(id, false);
            await this.service.modal.success('내부 메시지가 추가되었습니다.');
        } catch (error) {
            this.errorMessage = this.errorText(error, '내부 메시지 추가에 실패했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public async previousPage() {
        if (this.loading || this.pagination.page <= 1) return;
        this.filters.page = this.pagination.page - 1;
        await this.load();
    }

    public async nextPage() {
        if (this.loading || this.pagination.page >= this.pagination.total_pages) return;
        this.filters.page = this.pagination.page + 1;
        await this.load();
    }

    public workflowLabel(item: SaleRequestListItem | SaleRequestDetail) {
        if (item?.created_by_admin || item?.submission_channel === 'ADMIN') return '관리자 등록';
        return item?.admin_service_requested ? '판매등록 대행' : '일반 판매등록';
    }

    public workflowClass(item: SaleRequestListItem | SaleRequestDetail) {
        if (item?.created_by_admin || item?.submission_channel === 'ADMIN') {
            return 'border-teal-200 bg-teal-50 text-teal-700';
        }
        return item?.admin_service_requested
            ? 'border-violet-200 bg-violet-50 text-violet-700'
            : 'border-amber-200 bg-amber-50 text-amber-700';
    }

    public requestTypeLabel(type: SaleRequestType) {
        switch (type) {
            case 'CREATE': return '신규';
            case 'UPDATE': return '수정';
            case 'DELETE': return '삭제';
            default: return type;
        }
    }

    public statusLabel(status: SaleRequestStatus) {
        switch (status) {
            case 'SUBMITTED': return '접수';
            case 'IN_REVIEW': return '검수 중';
            case 'NEEDS_REVISION': return '보완 필요';
            case 'APPROVED': return '승인';
            case 'REJECTED': return '반려';
            case 'PUBLISHED': return '게시';
            case 'CANCELLED': return '취소';
            default: return status;
        }
    }

    public statusClass(status: SaleRequestStatus) {
        switch (status) {
            case 'SUBMITTED': return 'border-amber-200 bg-amber-50 text-amber-700';
            case 'IN_REVIEW': return 'border-sky-200 bg-sky-50 text-sky-700';
            case 'NEEDS_REVISION': return 'border-orange-200 bg-orange-50 text-orange-700';
            case 'APPROVED': return 'border-emerald-200 bg-emerald-50 text-emerald-700';
            case 'PUBLISHED': return 'border-teal-200 bg-teal-50 text-teal-700';
            case 'REJECTED': return 'border-rose-200 bg-rose-50 text-rose-700';
            case 'CANCELLED': return 'border-slate-300 bg-slate-100 text-slate-600';
            default: return 'border-slate-200 bg-white text-slate-500';
        }
    }

    public requestStatusLabel(item: SaleRequestListItem | SaleRequestDetail) {
        if (!this.isDeleteRequest(item)) return this.statusLabel(item.status);
        if (['SUBMITTED', 'IN_REVIEW', 'NEEDS_REVISION'].includes(item.status)) return '삭제 요청';
        if (item.status === 'APPROVED' || item.status === 'PUBLISHED') return '판매 종료 완료';
        if (item.status === 'REJECTED') return '삭제 반려';
        if (item.status === 'CANCELLED') return '삭제 취소';
        return this.statusLabel(item.status);
    }

    public requestStatusClass(item: SaleRequestListItem | SaleRequestDetail) {
        if (!this.isDeleteRequest(item)) return this.statusClass(item.status);
        if (['SUBMITTED', 'IN_REVIEW', 'NEEDS_REVISION'].includes(item.status)) {
            return 'border-rose-300 bg-rose-50 text-rose-700';
        }
        if (item.status === 'APPROVED' || item.status === 'PUBLISHED') {
            return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        }
        return this.statusClass(item.status);
    }

    public requestTypeClass(type: SaleRequestType) {
        switch (type) {
            case 'CREATE': return 'border-cyan-200 bg-cyan-50 text-cyan-700';
            case 'UPDATE': return 'border-violet-200 bg-violet-50 text-violet-700';
            case 'DELETE': return 'border-rose-200 bg-rose-50 text-rose-700';
            default: return 'border-slate-200 bg-white text-slate-500';
        }
    }

    public consentLabel(value: boolean) {
        return value ? '동의' : '미동의';
    }

    public documentCountLabel(item: SaleRequestListItem | SaleRequestDetail) {
        if (item?.has_no_documents) return '자료 없음';
        const count = item?.file_count;
        return count === null || count === undefined ? '확인 필요' : count + '개';
    }

    public auditEventLabel(event: AuditEvent) {
        return event?.event_type || '관리자 작업';
    }

    public auditSummary(event: AuditEvent) {
        const payload = event?.payload || {};
        return payload.reason
            || payload.message
            || payload.file_name
            || payload.status
            || payload.action
            || '';
    }

    public money(value: number | null) {
        if (value === null || value === undefined) return '-';
        return new Intl.NumberFormat('ko-KR', {
            style: 'currency',
            currency: 'KRW',
            maximumFractionDigits: 0
        }).format(value);
    }

    public fileSize(value: number) {
        const size = Number(value || 0);
        if (!size) return '0 B';
        if (size < 1024) return size + ' B';
        if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
        return (size / (1024 * 1024)).toFixed(1) + ' MB';
    }

    public formatDate(value: string) {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date);
    }

    private resetCreatePhone() {
        this.createPhone = { prefix: '010', middle: '', last: '' };
        this.syncCreatePhone();
    }

    private syncCreatePhone() {
        this.createDraft.seller.phone = this.createPhonePreview();
        this.createIdempotencyKey = '';
        this.createPayloadSnapshot = '';
    }

    private resetCreateEmail() {
        this.createEmail = { local: '', domain: '' };
        this.syncCreateEmail();
    }

    private syncCreateEmail() {
        this.createDraft.seller.email = this.createEmailPreview();
        this.createIdempotencyKey = '';
        this.createPayloadSnapshot = '';
    }

    private emptyDraft(adminServiceRequested: boolean = false): SaleRequestEditDraft {
        return {
            seller: { name: '', company: '', office_name: '', phone: '', email: '' },
            right: {
                right_type: adminServiceRequested ? 'PATENT' : '',
                category: '',
                field: '',
                technical_fields: [],
                right_title: '',
                owner_name: '',
                registration_number: '',
                registration_date: ''
            },
            desired_price: null,
            sale_method: adminServiceRequested ? 'NEGOTIABLE' : '',
            privacy_consent: false,
            fee_consent: false,
            admin_service_requested: adminServiceRequested,
            description: ''
        };
    }

    private validateDraft(draft: SaleRequestEditDraft, adminCreate: boolean = false) {
        if (!draft.seller.name.trim()) return '신청자명을 입력해주세요.';
        if (!draft.right.right_title.trim()) return '권리명을 입력해주세요.';
        if (!draft.right.right_type.trim()) return '권리구분을 입력해주세요.';
        if (adminCreate && draft.seller.phone && !/^01(?:0|1|6|7|8|9)-\d{4}-\d{4}$/.test(draft.seller.phone)) {
            return '연락처를 앞자리 선택 후 4자리-4자리 형식으로 입력해주세요.';
        }
        if (
            adminCreate
            && draft.seller.email
            && !/^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/.test(draft.seller.email)
        ) {
            return '이메일을 아이디@example.com 형식으로 입력해주세요.';
        }
        if ((draft.right.technical_fields || []).length > 2) {
            return '기술분야는 최대 2개까지 선택할 수 있습니다.';
        }
        if (adminCreate && draft.description.length > 300) return '기술특징은 300자 이하여야 합니다.';
        if (draft.desired_price !== null && Number(draft.desired_price) < 0) {
            return '희망 가격은 0원 이상으로 입력해주세요.';
        }
        return '';
    }

    private draftFromDetail(detail: SaleRequestDetail): SaleRequestEditDraft {
        return {
            seller: { ...this.emptyDraft().seller, ...(detail.seller || {}) },
            right: { ...this.emptyDraft().right, ...(detail.right || {}) },
            desired_price: detail.desired_price,
            sale_method: detail.sale_method || '',
            privacy_consent: !!detail.privacy_consent,
            fee_consent: !!detail.fee_consent,
            admin_service_requested: !!detail.admin_service_requested,
            description: detail.description || ''
        };
    }

    private normalizeListItem(item: any): SaleRequestListItem {
        const right = item?.right || {};
        const agreements = item?.agreements || {};
        const seller = item?.seller || {};
        const rawFileCount = item?.file_count ?? item?.attachment_count ?? item?.document_count;
        const fileCount = rawFileCount === null || rawFileCount === undefined || rawFileCount === ''
            ? null
            : Number(rawFileCount);
        return {
            ...item,
            seller,
            right: {
                ...right,
                technical_fields: Array.isArray(right.technical_fields)
                    ? right.technical_fields
                    : this.technicalFieldOptions.filter((field) =>
                        String(right.field || '').split(' · ').includes(field)
                    ),
                right_title: right.right_title || right.title || ''
            },
            desired_price: item?.desired_price ?? item?.price?.amount ?? null,
            privacy_consent: item?.privacy_consent ?? agreements.privacy ?? false,
            fee_consent: item?.fee_consent ?? agreements.fee ?? false,
            admin_service_requested: item?.admin_service_requested ?? false,
            target_sale_id: item?.target_sale_id
                || item?.target_listing_id
                || item?.listing_id
                || item?.target_sale?.id
                || item?.listing?.id
                || null,
            preferred_contact_time: item?.preferred_contact_time
                || item?.contact_preference
                || item?.requested_contact_time
                || item?.preferred_contact_window
                || item?.contact_time
                || seller.preferred_contact_time
                || seller.contact_time
                || '',
            has_no_documents: item?.has_no_documents === true,
            file_count: Number.isFinite(fileCount) ? fileCount : null
        } as SaleRequestListItem;
    }

    private normalizeDetail(detail: any): SaleRequestDetail {
        const normalized = this.normalizeListItem(detail) as SaleRequestDetail;
        normalized.description = detail?.description
            || detail?.user_request
            || detail?.request_notes
            || detail?.request_note
            || '';
        normalized.files = Array.isArray(detail?.files)
            ? detail.files.map((file: any) => ({
                ...file,
                file_name: file.file_name || file.name || '',
                file_type: file.file_type || file.type || 'DOCUMENT',
                mime_type: file.mime_type || file.content_type || '',
                size_bytes: file.size_bytes ?? file.size ?? 0,
                created_at: file.created_at || file.uploaded_at || ''
            }))
            : [];
        normalized.messages = Array.isArray(detail?.messages) ? detail.messages : [];
        normalized.status_history = Array.isArray(detail?.status_history) ? detail.status_history : [];
        normalized.audit_events = Array.isArray(detail?.audit_events)
            ? detail.audit_events
            : (Array.isArray(detail?.admin_action_history) ? detail.admin_action_history : []);
        normalized.file_count = normalized.files.length;
        normalized.has_no_documents = detail?.has_no_documents === true && normalized.files.length === 0;
        return normalized;
    }

    private validateDocument(file: File) {
        const allowed = ['pdf', 'jpg', 'jpeg', 'png', 'hwp', 'hwpx', 'doc', 'docx', 'xls', 'xlsx', 'zip'];
        const extension = (file.name.split('.').pop() || '').toLowerCase();
        if (!allowed.includes(extension)) {
            return 'PDF, 이미지, HWP, Word, Excel 또는 ZIP 서류만 탑재할 수 있습니다.';
        }
        if (!file.size) return '빈 서류는 탑재할 수 없습니다.';
        if (file.size > 20 * 1024 * 1024) return '서류는 파일당 20MB 이하여야 합니다.';
        return '';
    }

    private validateCreateImage(file: File) {
        const extension = (file.name.split('.').pop() || '').toLowerCase();
        if (!['jpg', 'jpeg', 'png'].includes(extension)) {
            return '탑재 이미지는 JPG 또는 PNG 형식만 선택할 수 있습니다.';
        }
        if (!file.size) return '빈 이미지는 탑재할 수 없습니다.';
        if (file.size > 20 * 1024 * 1024) return '이미지는 파일당 20MB 이하여야 합니다.';
        return '';
    }

    private uploadResponseData(response: any) {
        const payload = response?.responseJSON || response;
        const status = Number(payload?.code || response?.status || 200);
        if (!payload || status >= 400) {
            const message = payload?.data?.error?.message
                || payload?.error?.message
                || payload?.message
                || '서류 탑재에 실패했습니다.';
            throw new Error(message);
        }
        return payload.data;
    }

    private uploadErrorText(error: any, fallback: string) {
        const payload = error?.responseJSON || error;
        return payload?.data?.error?.message
            || payload?.error?.message
            || payload?.message
            || fallback;
    }

    private refreshPublishedListing(saleRequestId: string) {
        void this.loadPublishedListing(saleRequestId).then(async () => {
            if (this.selected?.id === saleRequestId) {
                await this.service.render();
            }
        });
    }

    private async loadPublishedListing(saleRequestId: string) {
        if (!this.selected || this.selected.id !== saleRequestId || this.selected.status !== 'PUBLISHED') return;
        try {
            const response = await wiz.call('list_sale_request_listings', { id: saleRequestId });
            if (response.code !== 200) return;
            const items = Array.isArray(response.data?.items) ? response.data.items : [];
            const listing = items.find((item: any) => item?.sale_request_id === saleRequestId)
                || items[0];
            if (!listing?.id || this.selected?.id !== saleRequestId) return;
            this.selected.target_sale_id = listing.id;
            this.publishResult = {
                listing_id: listing.id,
                listing_status: listing.status || 'PUBLISHED',
                reused: true
            };
        } catch (_error) {
            return;
        }
    }

    private async mutate(action: string, payload: any, success: string, fallback: string) {
        this.saving = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const id = this.selected?.id || '';
            const response = await wiz.call(action, payload);
            if (response.code !== 200) {
                throw new Error(this.responseError(response, fallback));
            }
            await this.loadDetail(id, false);
            await this.service.modal.success(success);
        } catch (error) {
            this.errorMessage = this.errorText(error, fallback);
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    private applyDetail(detail: SaleRequestDetail) {
        const normalized = this.normalizeDetail(detail);
        this.selected = normalized;
        this.editDraft = this.draftFromDetail(normalized);
        this.assigneeDraft = normalized.assigned_to || '';
        this.messageDraft = '';
        this.workflowReasonDraft = '';
        this.revisionComposerOpen = false;
    }

    private updateListItem(detail: SaleRequestDetail | null) {
        if (!detail) return;
        const index = this.items.findIndex((item) => item.id === detail.id);
        if (index < 0) return;
        this.items[index] = {
            ...this.items[index],
            reference: detail.reference,
            request_type: detail.request_type,
            status: detail.status,
            seller: detail.seller,
            right: detail.right,
            desired_price: detail.desired_price,
            sale_method: detail.sale_method,
            privacy_consent: detail.privacy_consent,
            fee_consent: detail.fee_consent,
            admin_service_requested: detail.admin_service_requested,
            assigned_to: detail.assigned_to,
            submitted_at: detail.submitted_at,
            updated_at: detail.updated_at,
            target_sale_id: detail.target_sale_id
            ,preferred_contact_time: detail.preferred_contact_time
            ,has_no_documents: detail.has_no_documents
            ,file_count: detail.file_count
        };
    }

    private responsePayload(response: any) {
        let payload = response?.responseJSON || response;
        if (!response?.responseJSON && typeof response?.responseText === 'string') {
            try {
                payload = JSON.parse(response.responseText);
            } catch (_parseError) { }
        }
        if (typeof payload === 'string') {
            try {
                return JSON.parse(payload);
            } catch (_parseError) { }
        }
        return payload;
    }

    private errorDetail(response: any) {
        const payload = this.responsePayload(response);
        let detail = payload?.data?.error
            || payload?.error?.data?.error
            || payload?.error?.error
            || payload?.error
            || response?.data?.error;
        if (typeof detail === 'string') {
            const parsed = this.responsePayload(detail);
            if (parsed !== detail) {
                detail = parsed?.data?.error || parsed?.error || parsed;
            }
        }
        if (detail && typeof detail === 'object' && !detail.code && !detail.message) {
            detail = detail?.data?.error || detail?.error || detail;
        }
        return typeof detail === 'string'
            ? { message: detail }
            : (detail && typeof detail === 'object' ? detail : null);
    }

    private responseError(response: any, fallback: string, includeCode: boolean = false) {
        const payload = this.responsePayload(response);
        const error = this.errorDetail(response);
        if (!error) {
            const status = response?.status || payload?.status || payload?.code;
            return includeCode && status
                ? '[HTTP ' + status + '] ' + fallback
                : fallback;
        }
        const messages: any = {
            CORE_API_PROXY_NOT_CONFIGURED: 'Core API 연동 설정이 필요합니다',
            CORE_API_UNAVAILABLE: 'Core API에 연결할 수 없습니다. 잠시 후 다시 시도해주세요.',
            UNAUTHORIZED: 'Core API 관리자 토큰을 확인해주세요.',
            ADMIN_AUTH_NOT_CONFIGURED: 'Core API 관리자 인증이 설정되지 않았습니다.',
            SALE_REQUEST_NOT_FOUND: '선택한 판매 요청을 찾을 수 없습니다.',
            SALE_REQUEST_NOT_APPROVABLE: '접수, 검수 중 또는 보완 필요 상태에서만 승인할 수 있습니다.',
            SALE_REQUEST_NOT_PUBLISHABLE: '최종 승인 후 공개 listing을 게시할 수 있습니다.',
            CORE_API_ADMIN_PUBLISH_INCOMPLETE: '관리자 판매등록이 공개 상태로 완료되지 않았습니다.',
            PRIVACY_CONSENT_REQUIRED: '판매자의 개인정보 처리 동의 확인이 필요합니다.',
            FEE_CONSENT_REQUIRED: '판매자의 수수료 안내 동의 확인이 필요합니다.',
            INVALID_IDEMPOTENCY_KEY: '관리자 판매등록 요청 식별자를 다시 생성해주세요.',
            IDEMPOTENCY_KEY_REUSED: '입력 내용을 변경한 뒤 다시 등록해주세요.',
            INVALID_REQUEST_TYPE: '판매 요청 유형을 확인해주세요.',
            INVALID_STATUS: '판매 요청 상태를 확인해주세요.',
            UNSUPPORTED_SALE_FILE_TYPE: '지원하지 않는 서류 형식입니다.',
            SALE_FILE_TOO_LARGE: '서류는 파일당 20MB 이하여야 합니다.'
            ,SALE_FILE_NOT_FOUND: '선택한 첨부파일을 찾을 수 없습니다.'
            ,SALE_FILE_DOWNLOAD_FAILED: '첨부파일을 내려받지 못했습니다.'
            ,INVALID_ASSISTED_FILTER: '판매등록 대행 필터 값을 확인해주세요.'
            ,SALE_REQUEST_NOT_DELETE: '판매 삭제 요청만 삭제 처리할 수 있습니다.'
            ,SALE_DELETE_NOT_PROCESSABLE: '접수, 검수 중 또는 보완 필요 상태의 삭제 요청만 처리할 수 있습니다.'
            ,DELETE_TARGET_LISTING_NOT_FOUND: '삭제할 판매를 찾지 못했습니다. 공개매물 연결 정보를 확인해주세요.'
            ,DELETE_TARGET_LISTING_AMBIGUOUS: '같은 등록번호의 판매가 여러 건입니다. 삭제 대상을 확인해주세요.'
            ,DUPLICATE_PENDING_DELETE: '이미 처리 대기 중인 판매 삭제 요청이 있습니다.'
            ,IDEMPOTENCY_KEY_REQUIRED: '판매 삭제 요청 식별키가 누락되었습니다. 화면을 새로고침한 뒤 다시 시도해주세요.'
            ,DELETE_REQUEST_ALREADY_PROCESSED: '이미 처리된 판매 삭제 요청입니다. 목록과 상세정보를 새로고침해주세요.'
            ,DELETE_REQUEST_STATUS_CHANGED: '판매 삭제 요청 상태가 변경되었습니다. 목록과 상세정보를 새로고침해주세요.'
            ,SALE_REQUEST_STATUS_CONFLICT: '판매 삭제 요청 상태가 변경되어 처리할 수 없습니다. 새로고침 후 확인해주세요.'
            ,SALE_DELETION_ALREADY_APPROVED: '이미 판매 공개 종료가 승인된 요청입니다.'
            ,SALE_DELETED_STATUS_UPDATE_FAILED: '판매는 삭제됐지만 요청 완료 상태를 반영하지 못했습니다. 새로고침 후 확인해주세요.'
            ,INVALID_REQUEST_ORIGIN: '허용되지 않은 요청입니다. 화면을 새로고침한 뒤 다시 시도해주세요.'
        };
        const message = includeCode
            ? (error.message || messages[error.code] || fallback)
            : (messages[error.code] || error.message || fallback);
        return includeCode && error.code
            ? '[' + error.code + '] ' + message
            : message;
    }

    private errorText(error: any, fallback: string, includeCode: boolean = false) {
        const payload = this.responsePayload(error);
        const detail = this.errorDetail(error);
        if (detail) {
            return this.responseError({ data: { error: detail } }, fallback, includeCode);
        }
        const message = payload?.message || error?.message || fallback;
        const status = error?.status || payload?.status;
        return includeCode && status && message === fallback
            ? '[HTTP ' + status + '] ' + message
            : message;
    }
}

export default PageIpMarketApplicationsComponent;